<template>
    <div>
        <card title="Objetivos de Muestra" icon="fas fa-crosshairs">
            <master-options @showModal="showModal" :links="links" @index="index" @reset="reset"></master-options>
            <div class="table-responsive">
                <manage-table :hover="true" :headers="['Id', 'Nombre', 'Requiere Detalle', 'Fecha Creación', 'Fecha Actualización']" :hasOptions="true">
                    <tr v-for="st in ListSampleTargets" :key="st.id">
                        <td>{{ st.id }}</td>
                        <td>{{ st.name }}</td>
                        <td>
                            <span :class="'badge ' + (st.requiresDetailSpecification ? 'badge-success' : 'badge-secondary')">
                                {{ st.requiresDetailSpecification ? 'Sí' : 'No' }}
                            </span>
                        </td>
                        <td>{{ st.createdAtString }}</td>
                        <td>{{ st.updatedAtString }}</td>
                        <td>
                            <button class="btn btn-info btn-sm mr-2" @click="showModal(st)" data-toggle="tooltip"
                                data-placement="top" title="Editar Objetivo de Muestra">
                                <i class="fas fa-edit"></i>
                            </button>
                            <button title="Eliminar Objetivo de Muestra" class="btn btn-danger btn-sm "
                                @click="deleteSampleTarget(st.id, st.name)" data-toggle="tooltip" data-placement="top">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </manage-table>
            </div>
            <paginator class="mt-4" :links="links"></paginator>
        </card>
        <modal id="sampleTargetFormModal" :title="modalTitle" @modalClose="index">
            <sample-target-form :sTarget="sTarget" @pressOk="save"></sample-target-form>
        </modal>
    </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper";
export default {
    components: {
        Card
    },
    data() {
        return {
            ListSampleTargets: [],
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            modalTitle: '',
            Get,
            Put,
            sTarget: {},
            links: {},
            getUrlQuery
        };
    },
    watch: {
        urlQuery: function () {
            this.index()
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/sampletarget?" + this.urlQuery, res => {
                this.ListSampleTargets = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });

        },
        reset() {
            this.links = {}
            this.index()
        },
        save() {
            if (this.sTarget.id)
                this.update()
            else
                this.store()

        },
        showModal(sTarget) {
            if (sTarget && sTarget.id) {
                this.modalTitle = "Actualizar Objetivo de Muestra";
                this.sTarget = sTarget;
            } else {
                this.modalTitle = "Crear Objetivo de Muestra";
                // Inicializar el booleano para que sea reactivo en el formulario (Vue 2).
                this.sTarget = { requiresDetailSpecification: false };
            }
            $('#sampleTargetFormModal').modal('show');
        },
        deleteSampleTarget(id, name) {
            this.$swal({
                title: "¿Desea eliminar el Objetivo de Muestra?",
                text: name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.value) {
                    this.Delete(this.apiUrl + 'v1/sampletarget/' + id, () => {
                        window.toastr.success('Objetivo de Muestra Eliminado correctamente.');
                        this.index();
                    });

                }

            });
        },
        update() {
            this.$store.commit("setLoading", true);
            this.Put(`${this.apiUrl}v1/sampletarget/` + this.sTarget.id, this.sTarget, () => {
                $('#sampleTargetFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Objetivo de Muestra Actualizado correctamente.');
                this.reset();
            });

        },
        store() {
            this.$store.commit("setLoading", true);
            this.Post(`${this.apiUrl}v1/sampletarget/`, this.sTarget, () => {
                $('#sampleTargetFormModal').modal('hide');
                this.$store.commit("setLoading", false);
                window.toastr.success('Objetivo de Muestra Registrado correctamente.');
                this.sTarget = {};
                this.reset();
            });

        }
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery()
        }
    }

}

</script>